import React from 'react';

import { Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

import CustomModal from './CustomModal';

interface TrialPeriodModalProps {
  open: boolean;
  onClose: () => void;
}

const TrialPeriodModal: React.FC<TrialPeriodModalProps> = ({
  open,
  onClose,
}) => {
  const { trialPeriodMessage, trialModalShown } = useSelector(
    (state: RootState) => state.auth
  );

  return (
    <CustomModal
      type="warning"
      open={open}
      onClose={onClose}
      autoClose={false}
      primaryButtonAction={onClose}
      primaryButtonLabel="I understand"
      title="Trial Period Notice"
      showSecondaryButton={false}
    >
      <Typography variant="body1" sx={{ fontWeight: 600, mb: 2 }}>
        {trialPeriodMessage || 'Trial Period Notice'}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Please proceed with caution and refer to the trial period terms and
        conditions for more information.
      </Typography>
    </CustomModal>
  );
};

export default TrialPeriodModal;
